/* bvm-paese.js — PAESE E LINGUA, il foglio (sessione M, 04/11/2026, v2). Markup: snippets/bvm-paese.liquid (un <dialog> nell'HTML),
   dati: snippets/bvm-paese-dati.liquid (JSON: testi IT/EN, nomi dei paesi con endonimi e alternativi), pillole: bvm-paese-pillola.liquid.
   · Testi: lo script li mette dal JSON e li scambia SUBITO al tocco del chip lingua (titolo, etichette, segnaposto, nomi delle tessere e
     dei paesi, messaggi, pulsanti). Niente caricato al tocco.
   · Lingua e paese: vince la scelta esplicita del chip; senza, la tessera porta la lingua predefinita del suo mercato (la prima delle
     lingue che Shopify dà per quel mercato). La riga sotto la tessera dice la lingua con cui si atterra davvero.
   · Tessera con più paesi (Europa): paese rilevato (Shopify, /browsing_context_suggestions.json) se sta nel mercato, o quello già scelto
     se si è già su quel dominio; altrimenti «Scegli il paese di consegna», la ricerca prende il fuoco e Conferma resta spento.
   · Cerca un paese: trova per nome italiano, inglese, endonimo, alternativi e codice ISO, senza maiuscole né accenti; il codice esatto
     viene prima. Un paese di un mercato sceglie quella tessera; uno «su richiesta» mostra il messaggio e «Contattaci».
   · Conferma: stesso mercato → modulo localization di Shopify (country_code + locale_code); altro mercato → il dominio del mercato con
     la stessa pagina (percorso senza il prefisso della lingua, lingua di atterraggio) e ?country=XX.
   · Contattaci: precompila paese e messaggio nel modulo richieste (snippets/bvm-richiesta.liquid) e apre Scrivici con #scrivici;
     senza Scrivici va alla pagina contatti. Apertura con showModal(): Esc, × e velo chiudono, il fuoco torna alla pillola. */
(function () {
  'use strict';
  var dlg = document.getElementById('bvm-paese');
  if (!dlg || dlg.__bvmPaese || typeof dlg.showModal !== 'function') return;
  dlg.__bvmPaese = true;
  var html = document.documentElement;
  var dati = {}; try { dati = JSON.parse(document.getElementById('bvm-paese-dati').textContent) || {}; } catch (e) {}
  var T = dati.testi || {}, P = dati.paesi || {}, L = dati.lingue || {};
  var corrente = { mercato: dlg.getAttribute('data-mercato') || '', paese: dlg.getAttribute('data-paese') || '', lingua: dlg.getAttribute('data-lingua') || 'it' };
  var el = function (s) { return dlg.querySelector(s); };
  var tutti = function (s) { return Array.prototype.slice.call(dlg.querySelectorAll(s)); };
  var tessere = tutti('[data-bvm-paese-tessera]'), lingue = el('[data-bvm-paese-lingue]');
  var campo = el('[data-bvm-paese-campo]'), elenco = el('[data-bvm-paese-elenco]'), voci = tutti('[data-bvm-paese-voce]'), nessuno = el('[data-bvm-paese-nessuno]');
  var scelto = el('[data-bvm-paese-scelto]'), sceltoBandiera = el('[data-bvm-paese-scelto-bandiera]'), sceltoNome = el('[data-bvm-paese-scelto-nome]');
  var richiesta = el('[data-bvm-paese-richiesta]'), richiestaTesto = el('[data-bvm-paese-richiesta-testo]'), contatta = el('[data-bvm-paese-contatta]');
  var form = document.getElementById('bvm-paese-form'), inPaese = el('[data-bvm-paese-country]'), inLingua = el('[data-bvm-paese-locale]'), conferma = el('[data-bvm-paese-conferma]');
  var pillole = Array.prototype.slice.call(document.querySelectorAll('[data-bvm-paese-apri]'));
  /* lo stato: la lingua scelta col chip (null = nessuna scelta esplicita), la tessera scelta, il paese (codice) e «su richiesta» */
  var linguaScelta = null, tessera = null, paese = null, richiestaAttiva = false, ultimoFuoco = null, chiestoRilevato = false, attiva = -1;

  function bandiera(codice) { return 'https://cdn.shopify.com/static/images/flags/' + String(codice).toLowerCase() + '.svg'; }
  function lista(s) { return (s || '').split(',').filter(Boolean); }
  function norma(s) { s = String(s || '').toLowerCase(); try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {} return s.replace(/\s+/g, ' ').trim(); }
  function tesseraDi(mercato) { return tessere.filter(function (x) { return x.getAttribute('data-mercato') === mercato; })[0]; }
  function vocePer(codice) { return voci.filter(function (v) { return v.getAttribute('data-paese') === codice; })[0]; }
  function pred(tes) { return tes.getAttribute('data-lingua-predefinita') || lista(tes.getAttribute('data-lingue'))[0] || 'en'; }
  /* la lingua con cui si atterra con questa tessera: quella scelta se il mercato la ha, altrimenti la predefinita del mercato */
  function atterro(tes) {
    var ls = lista(tes.getAttribute('data-lingue'));
    if (linguaScelta && ls.indexOf(linguaScelta) >= 0) return linguaScelta;
    /* senza scelta esplicita: nel mercato in cui si è già, si resta nella lingua della pagina; negli altri la predefinita del mercato */
    if (!linguaScelta && tes.getAttribute('data-mercato') === corrente.mercato && ls.indexOf(corrente.lingua) >= 0) return corrente.lingua;
    return pred(tes);
  }
  /* la lingua dei testi del foglio (e del chip acceso) */
  function linguaUI() { return linguaScelta || (tessera ? atterro(tessera) : corrente.lingua); }
  function tt(k, l) { l = l || linguaUI(); var d = T[l] || T.en || T.it || {}; return d[k] != null ? d[k] : ((T.it || {})[k] || ''); }
  function nomePaese(codice, l) { var d = P[codice]; if (d) return d[l] || d.en || d.it || codice; var v = vocePer(codice); return v ? (v.getAttribute('data-nome-shopify') || codice) : codice; }
  function endonimo(codice, l) { var d = P[codice]; if (!d || !d.endo) return ''; return norma(d.endo) === norma(nomePaese(codice, l)) ? '' : d.endo; }
  function nomeTessera(tes, l) {
    var unico = tes.getAttribute('data-unico'); if (unico) return nomePaese(unico, l);
    return tes.getAttribute('data-nome-' + l) || tes.getAttribute('data-nome-en') || tes.getAttribute('data-nome-shopify') || '';
  }
  function paeseDi(tes) { return tes.getAttribute('data-unico') || tes.getAttribute('data-paese') || ''; }
  function piuPaesi(tes) { return lista(tes.getAttribute('data-paesi')).length > 1; }

  /* ── i testi, tutti insieme, nella lingua del momento ── */
  function applicaTesti() {
    var l = linguaUI();
    dlg.setAttribute('lang', l);
    tutti('[data-bvm-paese-t]').forEach(function (e) { e.textContent = tt(e.getAttribute('data-bvm-paese-t'), l); });
    tutti('[data-bvm-paese-t-ph]').forEach(function (e) { e.placeholder = tt(e.getAttribute('data-bvm-paese-t-ph'), l); });
    tutti('[data-bvm-paese-t-aria]').forEach(function (e) { e.setAttribute('aria-label', tt(e.getAttribute('data-bvm-paese-t-aria'), l)); });
    tutti('[data-bvm-paese-chip-lingua]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lingua') === l ? 'true' : 'false'); });
    tessere.forEach(function (tes) {
      tes.querySelector('[data-bvm-paese-nome]').textContent = nomeTessera(tes, l);
      tes.querySelector('[data-bvm-paese-lingua]').textContent = atterro(tes).toUpperCase();
      tes.setAttribute('aria-pressed', tes === tessera ? 'true' : 'false');
    });
    voci.forEach(function (v) {
      var c = v.getAttribute('data-paese'); v.querySelector('[data-bvm-paese-voce-nome]').textContent = nomePaese(c, l);
      var e = v.querySelector('[data-bvm-paese-voce-endo]'); var en = endonimo(c, l); e.textContent = en; e.hidden = !en;
    });
    /* il paese scelto, o la richiesta di sceglierlo (tessera con più paesi senza paese) */
    if (richiestaAttiva && paese) { mostraScelto(paese, nomePaese(paese, l)); richiestaTesto.textContent = tt('richiesta', l).replace('{paese}', nomePaese(paese, l)); richiesta.hidden = false; form.hidden = true; }
    else {
      richiesta.hidden = true; form.hidden = false;
      if (tessera && piuPaesi(tessera)) { if (paese) mostraScelto(paese, nomePaese(paese, l)); else mostraScegli(tt('scegli', l)); }
      else scelto.hidden = true;
    }
    conferma.disabled = !tessera || richiestaAttiva || !(tessera.getAttribute('data-unico') || paese);
  }
  function mostraScelto(codice, nome) { scelto.hidden = false; scelto.classList.remove('bvm-paese__scelto--vuoto'); scelto.querySelector('.bvm-paese__sr').hidden = false; sceltoBandiera.hidden = false; sceltoBandiera.src = bandiera(codice); sceltoNome.textContent = nome; }
  function mostraScegli(testo) { scelto.hidden = false; scelto.classList.add('bvm-paese__scelto--vuoto'); scelto.querySelector('.bvm-paese__sr').hidden = true; sceltoBandiera.hidden = true; sceltoNome.textContent = testo; }

  /* i chip: quelli di Shopify per il mercato corrente, più le lingue degli altri mercati che mancano */
  (function () {
    var presenti = tutti('[data-bvm-paese-chip-lingua]').map(function (b) { return b.getAttribute('data-lingua'); });
    tessere.forEach(function (tes) { lista(tes.getAttribute('data-lingue')).forEach(function (c) {
      if (presenti.indexOf(c) >= 0) return; presenti.push(c);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bvm-paese__chip'; b.setAttribute('data-bvm-paese-chip-lingua', ''); b.setAttribute('data-lingua', c); b.setAttribute('lang', c); b.setAttribute('aria-pressed', 'false'); b.textContent = c.toUpperCase(); lingue.appendChild(b);
    }); });
    tutti('[data-bvm-paese-chip-lingua]').forEach(function (b) { var c = b.getAttribute('data-lingua'); if (L[c]) b.setAttribute('aria-label', L[c]); });
  })();

  /* ── le scelte ── */
  function scegliLingua(codice) { linguaScelta = codice; applicaTesti(); }
  function scegliTessera(tes, codice) {
    tessera = tes; richiestaAttiva = false;
    paese = codice || paeseDi(tes) || null;
    if (!codice) { campo.value = ''; chiudiElenco(); }
    applicaTesti();
    if (piuPaesi(tes) && !paese) { try { campo.focus({ preventScroll: true }); } catch (e) { campo.focus(); } }
  }
  function scegliVoce(v) {
    var codice = v.getAttribute('data-paese');
    campo.value = nomePaese(codice, linguaUI()); chiudiElenco();
    if (v.hasAttribute('data-richiesta')) { tessera = null; paese = codice; richiestaAttiva = true; applicaTesti(); if (contatta) contatta.focus(); return; }
    var tes = tesseraDi(v.getAttribute('data-mercato'));
    if (tes) { scegliTessera(tes, codice); if (conferma) conferma.focus(); }
  }

  /* ── cerca un paese: le chiavi di ricerca di ogni voce (nomi, endonimo, alternativi, codice, nome di Shopify), senza accenti ── */
  voci.forEach(function (v, i) {
    var c = v.getAttribute('data-paese'), d = P[c] || {}, chiavi = [c, d.it, d.en, d.endo, v.getAttribute('data-nome-shopify')].concat(d.alt || []);
    if (d.endo) chiavi = chiavi.concat(d.endo.split('·'));
    v.setAttribute('data-cerca', chiavi.filter(Boolean).map(norma).join('|'));
    v.id = 'bvm-paese-v-' + i;
    v.addEventListener('click', function () { scegliVoce(v); });
  });
  function visibili() { return voci.filter(function (v) { return !v.hidden; }).sort(function (a, b) { return Number(a.style.order || 0) - Number(b.style.order || 0); }); }
  function segna(i) {
    var vs = visibili(); attiva = (i >= 0 && i < vs.length) ? i : -1;
    voci.forEach(function (v) { v.setAttribute('aria-selected', 'false'); });
    if (attiva >= 0) { vs[attiva].setAttribute('aria-selected', 'true'); campo.setAttribute('aria-activedescendant', vs[attiva].id); if (vs[attiva].scrollIntoView) vs[attiva].scrollIntoView({ block: 'nearest' }); }
    else campo.removeAttribute('aria-activedescendant');
  }
  function chiudiElenco() { elenco.hidden = true; nessuno.hidden = true; campo.setAttribute('aria-expanded', 'false'); segna(-1); }
  function filtra() {
    var q = norma(campo.value), n = 0;
    voci.forEach(function (v) {
      var chiavi = (v.getAttribute('data-cerca') || '').split('|'), c = norma(v.getAttribute('data-paese'));
      var ok = !!q && chiavi.some(function (k) { return k.indexOf(q) >= 0; });
      v.hidden = !ok; if (!ok) return; n++;
      /* prima il codice esatto, poi i nomi che cominciano così, poi il resto */
      v.style.order = q === c ? 0 : (chiavi.some(function (k) { return k.indexOf(q) === 0; }) ? 1 : 2);
    });
    elenco.hidden = !q || !n; nessuno.hidden = !q || n > 0;
    campo.setAttribute('aria-expanded', elenco.hidden ? 'false' : 'true'); segna(-1);
  }
  campo.addEventListener('input', filtra);
  campo.addEventListener('focus', function () { if (campo.value) filtra(); });
  campo.addEventListener('keydown', function (e) {
    var vs = visibili();
    if (e.key === 'ArrowDown') { if (elenco.hidden) { filtra(); vs = visibili(); } if (!vs.length) return; e.preventDefault(); segna(attiva + 1 >= vs.length ? 0 : attiva + 1); }
    else if (e.key === 'ArrowUp') { if (!vs.length || elenco.hidden) return; e.preventDefault(); segna(attiva <= 0 ? vs.length - 1 : attiva - 1); }
    else if (e.key === 'Enter') { e.preventDefault(); if (!elenco.hidden) { if (attiva >= 0 && vs[attiva]) scegliVoce(vs[attiva]); else if (vs.length === 1) scegliVoce(vs[0]); } }
    else if (e.key === 'Escape' && !elenco.hidden) { e.preventDefault(); e.stopPropagation(); chiudiElenco(); }
  });

  /* ── il paese rilevato (Shopify): va nelle tessere con più paesi, mai un predefinito di nascosto ── */
  function rileva() {
    if (chiestoRilevato || !window.fetch) return; chiestoRilevato = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle; if (!c) return;
        dlg.setAttribute('data-rilevato', c);
        tessere.forEach(function (tes) {
          if (!piuPaesi(tes) || tes.getAttribute('data-mercato') === corrente.mercato) return;
          if (lista(tes.getAttribute('data-paesi')).indexOf(c) < 0) return;
          var v = vocePer(c); if (!v || v.hasAttribute('data-richiesta')) return;
          tes.setAttribute('data-paese', c);
          if (tessera === tes && !paese) { paese = c; applicaTesti(); }
        });
      }).catch(function () {});
  }

  /* ── conferma e contatti ── */
  function urlAltrove(host, predDominio, lingua, codice) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var path = window.location.pathname;
    if (root !== '/') { if (path.indexOf(root) === 0) path = '/' + path.slice(root.length); else if (path + '/' === root) path = '/'; }
    var u = new URL('https://' + host + (lingua === predDominio ? '' : '/' + lingua) + path + window.location.search);
    u.searchParams.set('country', codice);
    return u.toString();
  }
  form.addEventListener('submit', function (e) {
    var codice = tessera ? (tessera.getAttribute('data-unico') || paese) : null;
    if (!tessera || richiestaAttiva || !codice) { e.preventDefault(); return; }
    var lingua = atterro(tessera);
    if (tessera.getAttribute('data-mercato') === corrente.mercato) {
      if (codice === corrente.paese && lingua === corrente.lingua) { e.preventDefault(); chiudi(); return; }
      inPaese.value = codice; inLingua.value = lingua; return;   /* il modulo localization di Shopify fa il resto */
    }
    e.preventDefault(); window.location.href = urlAltrove(tessera.getAttribute('data-host'), pred(tessera), lingua, codice);
  });
  contatta.addEventListener('click', function () {
    var l = linguaUI(), nome = paese ? nomePaese(paese, l) : '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-bvm-richiesta]'), function (m) {
      var p = m.querySelector('input[name="paese"]'); if (p && !p.value) p.value = nome;
      var tx = m.querySelector('textarea[name="messaggio"]'); if (tx && !tx.value) tx.value = tt('msg', l).replace('{paese}', nome);
    });
    chiudi();
    if (document.querySelector('[data-bvm-scrivici]')) { if (window.location.hash === '#scrivici') window.location.hash = ''; window.location.hash = '#scrivici'; }
    else window.location.href = dlg.getAttribute('data-contatti') || '/pages/contact';
  });

  /* ── apri e chiudi ── */
  function apri(da) {
    if (dlg.open) return;
    ultimoFuoco = da || document.activeElement;
    if (!tessera && !richiestaAttiva) { var tes = tesseraDi(corrente.mercato) || null; tessera = tes; paese = tes ? (paeseDi(tes) || null) : null; }
    applicaTesti();
    dlg.showModal(); html.classList.add('bvm-paese-aperto');
    pillole.forEach(function (p) { p.setAttribute('aria-expanded', 'true'); });
    var primo = tutti('[data-bvm-paese-chip-lingua][aria-pressed="true"]')[0] || el('[data-bvm-paese-chiudi]');
    if (primo) { try { primo.focus({ preventScroll: true }); } catch (e) { primo.focus(); } }
    rileva();
  }
  function chiudi() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    html.classList.remove('bvm-paese-aperto');
    pillole.forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
    if (ultimoFuoco && ultimoFuoco.focus && document.contains(ultimoFuoco)) { try { ultimoFuoco.focus({ preventScroll: true }); } catch (e) { ultimoFuoco.focus(); } }
  });
  dlg.addEventListener('cancel', function (e) { if (!elenco.hidden) { e.preventDefault(); chiudiElenco(); } });
  /* l'Esc non deve chiudere anche il menu mobile sotto (che ascolta sul documento): si ferma qui, il dialog si chiude da solo */
  dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
  dlg.addEventListener('click', function (e) {
    var x;
    if (e.target === dlg) { chiudi(); return; }   /* clic sul velo: il bersaglio è il <dialog> */
    if (e.target.closest('[data-bvm-paese-chiudi]')) { chiudi(); return; }
    if ((x = e.target.closest('[data-bvm-paese-tessera]'))) { scegliTessera(x); return; }
    if ((x = e.target.closest('[data-bvm-paese-chip-lingua]'))) { scegliLingua(x.getAttribute('data-lingua')); return; }
  });
  pillole.forEach(function (p) { p.addEventListener('click', function () { apri(p); }); });
  applicaTesti();
  window.bvmPaese = { apri: apri, chiudi: chiudi };
})();
